import { filterOption } from "models/filterOption";
import { useCallback, useEffect, useMemo, useState } from "react";

import { FilterType } from "components/Reports/reportAssets/assets";
import { savedFilterType } from "components/SavedFIlters/savedFilter.types";
import { LocalStorageKey, useGetUserData } from "common/helpers/userData";
import { GetFilterOptions } from "./FIlterOptionsType/getFilterOptions";
import useFilterOptionsUtils from "./filterOptionsUtils";

const useFilterOptions = (filterType: FilterType) => {
  const { value: selectedRoleValue } = useGetUserData(
    LocalStorageKey.SelectedRole
  );
  useEffect(() => {
    setIsOpenMultiSelect(false);
    setIsOpenSavedFilter(false);
  }, [selectedRoleValue]);
  const isFilterOnServerSide =
    filterType === FilterType.volunteersType ||
    filterType === FilterType.controllersType;
  const { setFilterOptionsData } = useFilterOptionsUtils();

  const allFiltersMemo = GetFilterOptions();

  const filterOptionsObject = useMemo(() => {
    const filterOptionsMap = {
      [FilterType.reportType]: allFiltersMemo?.filterOptionsReport,
      [FilterType.controllersType]: allFiltersMemo?.filterOptionsController,
      [FilterType.volunteersType]: allFiltersMemo?.filterOptionsVolunteer,
    };

    return filterOptionsMap[filterType];
  }, [filterType, allFiltersMemo]);

  const [filtersOptions, setFiltersOptions] =
    useState<filterOption>(filterOptionsObject);

  const [runFilter, setRunFilter] = useState(false);
  const [chosenFilter, setChosenFilter] = useState<savedFilterType | object>(
    {}
  );

  const filterOptionInit = useCallback(() => {
    setFiltersOptions(filterOptionsObject);
  }, [filterOptionsObject]);

  const setDataToFiltersOptions = (data) => {
    filterOptionInit();
    const updatedOptions: {
      id;
      options;
      filterName?: string;
      name?: string;
    } = {
      id: data.id,
      options: setFilterOptionsData(filterOptionsObject.options, data),
    };
    if (isFilterOnServerSide) {
      updatedOptions.filterName = data.filterName;
    } else {
      updatedOptions.name = data.name;
    }
    setFiltersOptions(updatedOptions);
  };

  const filtersOptionsToDBFormat = (updatedfiltersOptions: filterOption) => {
    const convertedOptions = {};

    updatedfiltersOptions.options.forEach((option) => {
      if (option.value != null) {
        if (option.value instanceof Date) {
          const formattedDate = option.value.toDateString();

          convertedOptions[option.field] = formattedDate;
        } else {
          convertedOptions[option.field] = option.value;
        }
      }
    });

    const savedFilterName = isFilterOnServerSide
      ? { filterName: updatedfiltersOptions.filterName }
      : { name: updatedfiltersOptions.name };
    if (updatedfiltersOptions.id) {
      const commonOptions = {
        ID: updatedfiltersOptions.id,
        userRoleCode: selectedRoleValue,
        ...convertedOptions,
      };

      return {
        ...savedFilterName,
        ...commonOptions,
      };
    }

    return {
      ...savedFilterName,
      ...convertedOptions,
    };
  };

  const checkForSavedData = (datepickerName, savedFilterDataForDates) => {
    return new Date(savedFilterDataForDates[datepickerName]);
  };

  const [isOpenSavedFilter, setIsOpenSavedFilter] = useState(false);
  const closeSavedFilterComponent = () => {
    setIsOpenSavedFilter(false);
  };

  const [isOpenMultiSelect, setIsOpenMultiSelect] = useState(false);
  const openMultiSelect = () => {
    setIsOpenMultiSelect(true);
  };

  const toggleOpenMultiSelect = () => {
    if (!isOpenMultiSelect) {
      setIsOpenSavedFilter(false);
    }
    setIsOpenMultiSelect(!isOpenMultiSelect);
  };

  const toggleOpenSavedFilter = () => {
    if (!isOpenSavedFilter) {
      setIsOpenMultiSelect(false);
    }
    setIsOpenSavedFilter(!isOpenSavedFilter);
  };

  return {
    filtersOptions,
    setFiltersOptions,
    filterOptionInit,
    setDataToFiltersOptions,
    runFilter,
    setRunFilter,
    filtersOptionsToDBFormat,
    chosenFilter,
    setChosenFilter,
    checkForSavedData,
    isOpenSavedFilter,
    closeSavedFilterComponent,
    isOpenMultiSelect,
    setIsOpenMultiSelect,
    setIsOpenSavedFilter,
    openMultiSelect,
    toggleOpenMultiSelect,
    toggleOpenSavedFilter,
    filterOptionsObject,
  };
};

export default useFilterOptions;
